export default {
  euro: function(value) {
    return Number(value).toLocaleString("pt-PT", {
      style: "currency",
      currency: "EUR"
    });
  }
};
